var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256c-11.1,0-256,33.4-256,33.4L0,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.9,203.6l21.7,15.8l-8.3,25.5l21.7-15.8l21.7,15.8l-8.3-25.5l21.7-15.8l-26.8,0l-8.3-25.5l-8.3,25.5 L220.9,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320,145.1c-20.2-11.6-42.2-17.1-64-17.1v33.4c16.1,0,32.4,4,47.3,12.6c45.2,26.1,60.7,84.1,34.6,129.2 c-26.1,45.2-84.1,60.7-129.2,34.6c-13.2-7.6-23.8-17.9-31.6-29.8l-27.9,18.4c10.6,16.1,25,30.1,42.8,40.3 c61.1,35.3,139.6,14.3,174.9-46.9C402.1,258.9,381.1,180.4,320,145.1L320,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.2,233.7c-8.9,16.2-2.9,36.5,13.3,45.3l108.4,59.3c-7.4,13.5-3.5,29.9,10,37.3l29.3,16 c13.5,7.4,30.4,2.4,37.8-11.1l16-29.3L182.2,233.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/ao.5328cd842cebbb881e78433123153c4e.svg";
export { ForwardRef as ReactComponent };